import React, { useEffect, useState } from "react";

import CategoryDataService from "../../services/CategoryService";

import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import Button from "@material-ui/core/Button";
import Modal from "@material-ui/core/Modal";
import { CategoryDetailsModal } from "./CategoryModals";

const CategoryItem = ({ category, domains, getAll, allGroups }) => {
  const { id } = category;

  //delete modal isOpen
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  //DETAILS MODAL
  const [detailsModalOpen, setDetailsModalOpen] = useState(false);

  const [displayDomain, setDisplayDomain] = useState("");

  //open delete modal
  const openDeleteModal = () => {
    setDeleteModalOpen(true);
  };

  //cancel delet modal
  const handleDeleteClose = () => {
    setDeleteModalOpen(false);
  };

  //confirm delete from modal
  const confirmDelete = () => {
    CategoryDataService.deleteCategory(id)
      .then((response) => {
        console.log(response);
        window.location.reload(false);
      })
      .catch((error) => console.log("error while deleting category: " + error));
  };

  //open details modal
  const openDetailsModal = () => {
    setDetailsModalOpen(true);
  };

  // CLOSE DETAILS MODAL
  const closeDetailsModal = () => {
    setDetailsModalOpen(false);
  };

  //set domain name to display
  useEffect(() => {
    // console.log("category: ", category);
    // console.log("domains: ", domains);
    // console.log("allGroups: ", allGroups);
    if (domains && domains.length && domains.length > 0 && category && category.group) {
      const currentDomain = domains.find((d) => {
        return d.id === category.group.domain_id;
      });
      setDisplayDomain(currentDomain.name);
    }
  }, [domains, category]);

  return (
    <>
      <b> {category.name} </b>
      <div style={{ display: "flex", justifyContent: "center" }}>
        {category.group ? `${displayDomain} -  ${category.group.name}` : "No group"}
      </div>

      <div className={"ci-buttons"}>
        {/* ORDER NUJM */}

        <IconButton aria-label="edit" color="primary" onClick={() => openDetailsModal()}>
          <EditIcon />
        </IconButton>

        <IconButton aria-label="delete" color="secondary" onClick={() => openDeleteModal()}>
          <DeleteIcon />
        </IconButton>
      </div>
      {/* MODALS */}
      <>
        <CategoryDetailsModal
          category={category}
          isOpen={detailsModalOpen}
          onClose={closeDetailsModal}
          getAll={getAll}
          setIsOpen={setDetailsModalOpen}
          allGroups={allGroups}
          domains={domains}
        />
      </>
      <>
        <Modal open={deleteModalOpen} onClose={handleDeleteClose} className="delete-modal">
          <div className="delete-modal-content">
            <h3>Are you sure you want to delete "{category.name}"?</h3>
            <div className="delete-buttons" style={{ marginTop: "20px" }}>
              <Button
                style={{
                  padding: "20px",
                }}
                color="secondary"
                onClick={confirmDelete}
              >
                Delete
              </Button>
              <Button style={{ padding: "20px" }} color="primary" onClick={handleDeleteClose}>
                Cancel
              </Button>
            </div>
          </div>
        </Modal>
      </>
    </>
  );
};

export default CategoryItem;
